<template>
  <div class="repair headFixed">
    <div class="fixed_head">
      <div class="go_back">在线报修</div>
    </div>
    <div style="height:44px;background-color: transparent;"></div>
    <ul class="nav clear container">
      <li :class="'active'">服务需求</li>
    </ul>
    <div class="tab-content">
      <div class="tabItem tabItem2">
        <div class="item">
          <label>姓&nbsp;&nbsp;&nbsp;&nbsp;名:</label>
          <div><input type="text" name="" v-model="name" placeholder="请输入姓名"/></div>
        </div>
        <div class="item">
          <div class="phone-input-container">
            <label>手机号&nbsp;:</label>
            <input
                type="number"
                maxlength="11"
                name=""
                v-model="phonenumber"
                placeholder="请输入电话"
                class="phone-input"/>
            <button
                v-if="!isCounting"
                @click="getVerificationCode"
                class="get-code-btn">
              获取验证码
            </button>
            <button
                v-if="isCounting"
                disabled
                class="get-code-btn disabled">
              {{ countdown }}s
            </button>
          </div>
        </div>
        <div class="item">
          <label>验证码:&nbsp;</label>
          <div><input type="number" name="" v-model="code" placeholder="请输入验证码"/></div>
        </div>
        <div class="item">
          <label>设备名称:</label>
          <div><input type="text" name="" v-model="deviceName" placeholder="请输入设备名称"/></div>
        </div>
        <div class="item">
          <label>型&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号:</label>
          <div><input type="text" name="" v-model="deviceModel" placeholder="请输入设备型号"/></div>
        </div>
        <div class="item border-none">
          <label>故障描述:</label>
          <div><textarea name="" v-model="faultContent" placeholder="请输入故障描述"></textarea></div>
        </div>
      </div>
    </div>

    <div class="container submitBtn">
      <div class="btn-group">
        <mt-button size="large" type="primary" @click="submitRequire()" class="">提交</mt-button>
      </div>
    </div>
  </div>
</template>

<script>
import {Toast} from 'mint-ui';

export default {
  name: 'repair',
  data() {
    return {
      tab: 0,
      name: null,
      phonenumber: null,
      code: null,
      deviceName: null,
      deviceModel: null,
      faultContent: null,
      isCounting: false, // 是否正在倒计时
      countdown: 60,      // 倒计时的秒数
      timer: null,        // 用于保存计时器
    };
  },
  methods: {
    // 获取验证码方法
    getVerificationCode() {
      if (!this.phonenumber) {
        Toast('请输入手机号');
        return;
      }

      // 开始倒计时
      this.isCounting = true;
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.timer);
          this.isCounting = false;
          this.countdown = 60; // 重置倒计时
        }
      }, 1000);

      // 发送验证码请求
      this.sendVerificationCode();
    },

    // 模拟发送验证码
    sendVerificationCode() {
      // 假设验证码发送请求成功
      Toast('验证码已发送，请查收');
    },

    submitRequire() {
      let params = {};
      params.name = this.name;
      params.phonenumber = this.phonenumber;
      params.code = this.code;
      params.deviceName = this.deviceName;
      params.deviceModel = this.deviceModel;
      params.faultContent = this.faultContent;

      // 进行表单校验
      if (!this.name) {
        Toast('请填写姓名');
        return false;
      }
      if (!this.phonenumber) {
        Toast('请填写手机号');
        return false;
      }
      if (!this.code) {
        Toast('请填写验证码');
        return false;
      }
      if (!this.faultContent) {
        Toast('请填写故障描述');
        return false;
      }

      // 提交请求
      this.Api.equipmentRepairAddWx(params, msg => {
        if (msg.code === 200) {
          Toast('报修成功,我们会尽快与您联系');
          this.handelReset();
        } else {
          Toast('报修失败，请稍后重试');
        }
      });
    },
  },
  beforeDestroy() {
    // 清理定时器
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>

<style scoped>
@import url('../headNav/headNav.css');
@import url('../../assets/list.css');
@import url('./repair.css');

.repairPicker .mint-popup {
  border-radius: 0;
  width: 100%;
}

.submitBtn .btn-group {
  display: flex;
  justify-content: space-between;
}

.phone-input-container {
  display: flex; /* 设置Flexbox布局 */
  justify-content: space-evenly; /* 子元素之间的间隔 */
  align-items: center;
}

.phone-input {
  flex: 1;
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.get-code-btn {
  background-color: #ff9800;
  color: #fff;
  border: none;
  padding: 8px 16px;
  margin-left: 10px;
  cursor: pointer;
  border-radius: 4px;
}

.get-code-btn.disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/repairWx/repair.vue